<template>
    <div class="content mt20">
       <div class="account-content bgfff">
            <vipMenu></vipMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff clearfix">
            <div class="purchase fl w740">
                <div class="title">{{infomation.description}}</div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99">剩余清贝：</label>
                    <div class="text fl">
                        <span>{{infomation.qinBei}}</span>
                    </div>
                </div>
                <div class="form-group1 clearfix" v-if="infomation.diQinbei > 0">
                    <label class="control-label color-8a8a99">会员抵扣：</label>
                    <div class="text fl">
                        <span>{{infomation.des}}</span>
                    </div>
                </div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99">充值服务：</label>
                    <div class="text fl">
                        <span>{{infomation.service}}</span>
                    </div>
                </div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99">充值账号：</label>
                    <div class="text fl">
                        <span>{{infomation.userinfo}}</span>
                    </div>
                </div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99 mt5">充值方式：</label>
                    <div class="one-bd fl">
                        <div class="fl">
                            <a :class="{active:buyTimeType === 1}" v-if="level != 20" href="javascript:void(0);" @click="timeTab(1);">按月</a>
                            <a :class="{active:buyTimeType === 2}" href="javascript:void(0);" @click="timeTab(2);">按年</a>
                        </div>
                    </div>
                </div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99 mt10">开通时长：</label>
                    <div class="text fl">
                        <input type="text" class="input-text input-numb w80 ac"  v-model="number" @keyup="inputNumber();"/>
                        <span class="fs16 color-8a8a99 ml5">{{buyTimeType === 1 ? '月' : '年'}}</span>
                    </div>
                </div>
                <div class="form-group1 clearfix" v-if="level === 20">
                    <label class="control-label color-8a8a99 mt10">机构名称：</label>
                    <div class="text fl">
                        <input type="text" class="input-text input-numb w320" v-model="companyName" maxlength="10" placeholder="请输入机构名称，不超过10个字" />
                    </div>
                </div>
                <div class="form-group1 clearfix" v-if="level === 20">
                    <label class="control-label color-8a8a99 mt10">机构logo：</label>
                    <div class="text fl">
                        <!-- <input type="text" class="input-text input-numb w215 fl" placeholder="logo尺寸：144px*144px" /> -->
                        <img :src="previewImg" class="logo-img fl" v-if="previewImg != ''"/>
                        <div class="up-load-a ac fl" :class="{ml20:previewImg != ''}">
                            <input type="file" value="本地上传" @change="updateImg($event);"/>
                            <span>本地上传</span>
                        </div>
                        <span class="text40 fl ml5">(logo尺寸：144px*144px)</span>
                    </div>
                </div>
                <div class="form-group1 clearfix">
                    <label class="control-label color-8a8a99 mt10">应付金额：</label>
                    <div class="checkbox fl">
                        <strong class="crf46 fs28">{{finalPrize}}</strong>
                        <span class="color-8a8a99">清贝</span>
                    </div>
                </div>
                <div class="btn-div mt50 ml20 clearfix">
                    <button class="btn btn-blue fl" @click="payment();">立即支付</button>
                </div>
            </div>
            <div class="examine mt30 w280 fl">
                <div class="examine-header">
                    <h4><i :class="$parent.vipCollocation[levelIndex].icon"></i>{{$parent.vipCollocation[levelIndex].name}}</h4>
                </div> 
                <div class="examine-body">
                    <ul>
                        <li v-for="(item,index) in infomation.plusInfo" :key="index">
                            <i class="icons dui-icon1"></i>
                            <span>{{item}}</span>
                        </li>
                    </ul>
                </div>
            </div>
       </div>
       <!-- 充值提示 -->
        <Dialog ref="payModal" :callback="enterPay" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认支付？</p>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
           infomation:[],//页面信息
           buyTimeType:1,
           timeNum:1,//购买单位相对应的数 非机构时 年是12 月是1 机构是年是1
           number:1,//购买数量
           levelIndex:0,
           previewImg:'',//logo图
           companyName:'',//机构名称
           level:'',//当前会员等级或要购买的等级
           finalPrize:'',//最终价格
           prize:'',//原来总价
           paytips:''//充值提示
        }
    },
    mounted() {
		let that = this;
        this.$nextTick(()=> {
            that.getInfomation();
        })
    },
    created() {
        this.level = parseInt(this.$route.query.level);
        if(this.level === 20){
            this.buyTimeType = 2;
        }
    },
    methods: {
        // 获取页面信息
        getInfomation () {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('personal/memberpay',{level:that.level},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.infomation = r.data;
                    that.levelIndex = that.$parent.levels.indexOf(r.data.level);
                    that.countPrize();
                })
            })
        },
        // 购买时间切换
        timeTab (type) {
            let that = this;
            let level = that.level;
            that.buyTimeType = type;
            if(level === 20){//机构
                that.timeNum = 1;
            }else{//非机构
                if(type === 1){//按月
                    that.timeNum = 1;
                }else{
                    that.timeNum = 12;
                }
            }
            that.countPrize(); 
        },
        // 计算价格
        countPrize () {
            let that = this;
            let infomation = that.infomation;
            let level = that.level;//当前购买的会员等级
            let qingBeiNum = infomation.price;//单价
            let discount = infomation.discount;//折扣
            let timeNum = that.timeNum;
            let number = that.number;//购买个数
            let conversionQingBeiNum = infomation.diQinbei;//会员时间抵扣
            let prize = qingBeiNum*number*timeNum-conversionQingBeiNum;//原本总价
            prize = prize.toFixed(2);
            let finalPrize = '';
            finalPrize = prize*discount;
            if(finalPrize < 0){
                finalPrize = 0;
            }
            that.finalPrize = finalPrize.toFixed(2);
        },
        inputNumber () {
            let that = this;
            let number = that.number;
            if(number != ''){
                number = number.replace(/[^\d\.]/g, '');
                let str = number.substr(0,1);
                if(str === '0' || str === '.'){
                number = number.substr(1);
                }
                that.number = number;
                if(number != ''){
                    that.number = parseInt(number);
                }
            }
            that.countPrize();  
        },
        // 图片上传
        updateImg (event) {
            let that = this;
            let file = event.target.files;
            let files = file[0];
            let formData = new FormData();
            formData.append('file', files);
            that.$api.post('mymaterial/upload', formData, r => {
                that.$parent.returnCode(r,function(){
                    that.previewImg = r.data;
                })
            })
        },
        // 支付
        payment () {
            if(this.infomation.qinBei - this.finalPrize < 0){
                this.$utils.alertText('余额不足');
                return;
            }else if(this.companyName === '' && this.infomation.level === 20){
                this.$utils.alertText('机构名称不能为空');
                return;
            }else if(this.previewImg === '' && this.infomation.level === 20){
                this.$utils.alertText('请上传机构logo');
                return;
            }else if(this.finalPrize <= 0){
                this.$utils.alertText('支付金额不能为0');
                return;
            }
            this.$refs.payModal.showMaskFun();
        },
        // 确认充值
        enterPay () {
            let that = this;
            let url = '';
            let level = that.level;
            let data = '';
            if(level === 20){//机构
                url = 'personal/orgpay';
                data = {
                    name:that.companyName,
                    logo:that.previewImg,
                    num:that.number
                }
            }else{//非机构
                url = 'personal/singlepay';
                data = {
                    type:that.infomation.deadline,
                    level:that.level,
                    num:that.number
                }
            }
            that.$refs.payModal.closeMask();
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post(url, data, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.$parent.getPower();//重新获取权限
                    that.$parent.alertTips('支付成功');
                    that.$router.push({path:'/personalCenter'});
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/memberPurchase.vue